<script setup lang="ts">
import { ORDER_STATUS } from "core/interfaces";

import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useModalStore } from "~/stores/modal";
import { useOrdersStore } from "~/stores/orders";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { ordersConfirmReject } = useModalStore();
const ordersStore = useOrdersStore();

const submitOrderReject = async () => {
	await ordersStore.patchById(ordersConfirmReject.order.id, {
		status: ORDER_STATUS.CANCELED
	});

	ordersConfirmReject.closeModal();

	if (route.name === "orders") {
		ordersStore.getAll({}, ordersStore.recentGetAllQuery);
	} else {
		ordersStore.currentOrder = await ordersStore.getById(ordersConfirmReject.order.id);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.ORDERS.CONFIRM_REJECT.alert.title"),
		description: t("COMPONENTS.ORDERS.CONFIRM_REJECT.alert.description", { nonce: ordersConfirmReject.order.id }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.ORDERS.CONFIRM_REJECT.title')"
		:description="$t('COMPONENTS.ORDERS.CONFIRM_REJECT.description', {nonce: ordersConfirmReject.order.id})"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesReject')"
		@close="ordersConfirmReject.closeModal"
		@submit="submitOrderReject"
	/>
</template>
